<template>
    <div class="hitchRideCancelRule">
        <custom-city-tree @city-selected="handleCitySelect" url="/api/v1/manage/hitchRide/refund/city"/>

        <div class="hitchRideCancelRule-content">
            <sellOrderRulesForm :cityData="{ ...selectCity }"></sellOrderRulesForm>
        </div>
    </div>
</template>

<script>
import CustomCityTree from './components/CustomCityTree.vue';
import sellOrderRulesForm from "./components/sellOrderRulesForm.vue";
export default {
    components: { CustomCityTree, sellOrderRulesForm },
    data() {
        return {
            selectCity: {}
        };
    },
    computed: {},
    created() {

    },
    methods: {
        handleCitySelect(node) {
            this.selectCity = node;
        }
    }
};
</script>

<style lang="less" scoped>
.hitchRideCancelRule {
    display: flex;

    &-content {
        padding: 16px;
        flex: 1;
        max-height: calc(100vh - 240px);
        overflow-y: auto;
    }
}
</style>